import { createContext, useContext, useRef } from 'react'

const LocationInputContext = createContext<React.RefObject<HTMLInputElement | null> | null>(null)

export const useLocationInputRef = () => {
  const ref = useContext(LocationInputContext)
  if (!ref) {
    throw new Error('useLocationInputRef must be used within a LocationInputProvider')
  }
  return ref
}

export const LocationInputProvider = ({ children }: { children: React.ReactNode }) => {
  const ref = useRef<HTMLInputElement>(null)
  return <LocationInputContext.Provider value={ref}>{children}</LocationInputContext.Provider>
}
